<div class="publish">
    <app-toggle [formGroup]="formPublish" [meta]="metaHidden" [model]="$safeNavigationMigration(node()?.publish?.hidden)"></app-toggle>
    <app-datetime [formGroup]="formPublish" [meta]="metaTimeOn" [model]="$safeNavigationMigration(node()?.publish?.timeOn)"></app-datetime>
    <app-datetime [formGroup]="formPublish" [meta]="metaTimeOff" [model]="$safeNavigationMigration(node()?.publish?.timeOff)"></app-datetime>
</div>
